export default __webpack_public_path__ + "static/B0252-8e5c202952e1a5bc656522364a692586.png";